import { Card } from "./Card";
import { OnboardingData, View } from "../types";
import { FC } from "react";

type Props = {
  setView: (view: View) => void;
  data: OnboardingData;
};

export const RootView: FC<Props> = ({ setView, data }) => {
  const isCompleted =
    data.kyb_verification &&
    !data.billing.bank_account_required &&
    data.identity_verification.status !== "pending";

  return (
    <div className="animate-appear mt-8 flex flex-col items-center justify-center">
      <p className="mb-2 text-2xl font-bold text-content-1000">
        {isCompleted ? "Reviewing your account" : "Getting started with Boom"}
      </p>
      <p className="mb-8 whitespace-pre-line text-center text-base font-medium text-content-300">
        {isCompleted
          ? `You have successfully provided information to get started with Boom.${"\n"}When approved, we'll send you an email to notify you. You'll also be${"\n"}able to log in to the Partner Portal and begin enrolling renters`
          : `To get started using the Boom Partner platform${"\n"}complete 3 simple steps`}
      </p>
      <div className="px-4">
        <Card
          title="Identity verification"
          description={`We verify the identity of our partners to prevent fraud per${"\n"}our Terms of Use`}
          onClick={() => {
            setView(View.IDV);
          }}
          status={data.identity_verification.status}
          stepCompleted={data.identity_verification.status === "finished"}
        />
        <Card
          title="Business verification"
          description={`We collect information about partners to ensure compliance${"\n"}with regulatory requirements`}
          onClick={() => setView(View.KYB)}
          status={data.kyb_verification?.status}
          stepCompleted={data.kyb_verification?.status === "pending"}
        />
        <Card
          title="Connect payment method"
          description={`Link your bank account to get started creating${"\n"}enrollments`}
          onClick={() => setView(View.Billing)}
          stepCompleted={!data.billing.bank_account_required}
        />
      </div>
    </div>
  );
};
